import api from './api';

export const adminService = {
  async getStates() {
    const { data } = await api.get('/admin/states');
    return data;
  },

  async importStates() {
    const { data } = await api.post('/admin/states/import');
    return data;
  },

  async fetchStateBoundary(id: string) {
    const { data } = await api.post(`/admin/states/${id}/fetch-boundary`);
    return data;
  },

  async updateState(id: string, payload: any) {
    const { data } = await api.put(`/admin/states/${id}`, payload);
    return data;
  },

  async deleteState(id: string) {
    await api.delete(`/admin/states/${id}`);
  },

  async getCities() {
    const { data } = await api.get('/admin/cities');
    return data;
  },

  async importCities(stateId: string) {
    const { data } = await api.post(`/admin/cities/import/${stateId}`);
    return data;
  },

  async fetchCityBoundary(id: string) {
    const { data } = await api.post(`/admin/cities/${id}/fetch-boundary`);
    return data;
  },

  async getUsers() {
    const { data } = await api.get('/admin/users');
    return data;
  },

  async createUser(payload: { name: string; email: string; password: string; cityId: string; userType: string }) {
    const { data } = await api.post('/admin/users', payload);
    return data;
  },

  async updateUser(id: string, payload: any) {
    const { data } = await api.put(`/admin/users/${id}`, payload);
    return data;
  },

  async deleteUser(id: string) {
    await api.delete(`/admin/users/${id}`);
  },

  async updateCity(id: string, payload: any) {
    const { data } = await api.put(`/admin/cities/${id}`, payload);
    return data;
  },

  async deleteCity(id: string) {
    await api.delete(`/admin/cities/${id}`);
  },

  async getCategories() {
    const { data } = await api.get('/admin/categories');
    return data;
  },

  async createCategory(payload: { name: string; description?: string; icon?: string; color?: string; pin?: string | null; cityId: string }) {
    const { data } = await api.post('/admin/categories', payload);
    return data;
  },

  async updateCategory(id: string, payload: any) {
    const { data } = await api.put(`/admin/categories/${id}`, payload);
    return data;
  },

  async deleteCategory(id: string) {
    await api.delete(`/admin/categories/${id}`);
  },
};
